<script setup>

</script>

<template>
    <div class="w-full flex flex-col items-center justify-center">
        <div class="w-full bg-white p-4 lg:p-[25px] border border-[#e1e1e1] rounded-[16px]">
            <div class="font-bold text-[18px] lg:text-[20px] mb-4 lg:mb-[32px]">Способ оплаты</div>
            <div class="w-full">
                <div class="flex flex-col items-start justify-center gap-2 border-blue-500 bg-blue-50 cursor-default select-none border-2 px-[18px] py-[18px] w-full rounded-[12px]">
                    <div class="font-bold text-base">Банковская карта</div>
                    <div>Выберите этот способ если оплачиваете в рублях</div>
                </div>
            </div>

        </div>
    </div>
</template>

<style scoped>

</style>